export const allBackdrops: IBackdrops = {
  'B-001': {
    id: 'B-001',
    url: '',
    thumbnailUrl: '',
    name: 'Verdant Caverns',
    description: 'A fusion of concrete and nature, where light filters through organic curves.',
  },
  'B-002': {
    id: 'B-002',
    url: '',
    thumbnailUrl: '',
    name: 'Luminara Passage',
    description: 'A neon-lit tunnel in Neo-Tokyo, leading to the electrified Neon District.',
  },
  'B-003': {
    id: 'B-003',
    url: '',
    thumbnailUrl: '',
    name: 'Xyphora Prime',
    description: 'A glowing alien wasteland with bioluminescent rivers and towering monoliths.',
  },
  'B-004': {
    id: 'B-004',
    url: '',
    thumbnailUrl: '',
    name: 'Eldoria Forest',
    description: 'An ancient forest where golden lights dance along a winding path.',
  },
  'B-005': {
    id: 'B-005',
    url: '',
    thumbnailUrl: '',
    name: 'Tokyo 2050',
    description: 'A cyberpunk city drenched in neon and rain, alive with holographic ads.',
  },
  'B-006': {
    id: 'B-006',
    url: '',
    thumbnailUrl: '',
    name: 'Horizon Retreat',
    description: 'A fluid, oceanfront sanctuary bathed in golden sunset hues.',
  },
  'B-007': {
    id: 'B-007',
    url: '',
    thumbnailUrl: '',
    name: 'Celestial Haven',
    description: 'A sleek cliffside dwelling with panoramic views of an alien sea.',
  },
  'B-008': {
    id: 'B-008',
    url: '',
    thumbnailUrl: '',
    name: 'Aeon Spire',
    description: 'A futuristic, flowing structure merging light, space, and serenity.',
  },
  'B-009': {
    id: 'B-009',
    url: '',
    thumbnailUrl: '',
    name: 'Cosmic Void',
    description: 'A cosmic expanse adorned with luminous star clusters and brilliant stars.',
  },
  'B-010': {
    id: 'B-010',
    url: '',
    thumbnailUrl: '',
    name: 'Medieval Village',
    description: 'A picturesque medieval village basking under the warm glow of the sun.',
  },
  'B-011': {
    id: 'B-011',
    url: '',
    thumbnailUrl: '',
    name: 'Desert Sketch',
    description: 'A minimalist desert landscape with a single, towering rock formation.',
  },
  'B-012': {
    id: 'B-012',
    url: '',
    thumbnailUrl: '',
    name: 'Game-like Desert',
    description: 'A stylized desert landscape with low-poly cacti and a distant pyramid.',
  },
  'B-013': {
    id: 'B-013',
    url: '',
    thumbnailUrl: '',
    name: 'New York Studio',
    description: 'A spacious, bedroom studio in New York City with a view of east village.',
  },
};
